<tds-button id="reservation-list" text="Reservas" size="md"></tds-button>
<tds-modal header="Lista de reservas" selector="#reservation-list" id="reservation-list" size="lg" actions-position="static">
  <span slot="body">
      <div class="reservation-list">
          <tds-table
            vertical-dividers="false"
            compact-design="false"
            responsive
            no-min-width
            (tdsSort)="sort($event)"
            >
          <tds-table-toolbar
                table-title="Filter"
                filter
                (tdsFilter)="handleFilter($event)"
            ></tds-table-toolbar>
          <tds-table-header>

              <tds-header-cell
                cell-key="tableName"
                cell-value="Mesa"
                text-align="left"
                sortable="true"
                ></tds-header-cell>

              <tds-header-cell
                cell-key="empName"
                cell-value="Nome"
                sortable="true"
                ></tds-header-cell>

              <tds-header-cell
                cell-key="area"
                cell-value="Depart"
                sortable="true"
                ></tds-header-cell>

              <tds-header-cell
                cell-key="username"
                cell-value="Usuário"
                sortable="true"
                ></tds-header-cell>

          </tds-table-header>
          <tds-table-body>
                @for( row of tableData(); track `${row.reservationId}_${$index}`){

                  <tds-table-body-row>
                      <tds-body-cell cell-key="tableName">
                            {{ row.tableName }}
                      </tds-body-cell>
                      <tds-body-cell cell-key="empName">
                            {{ row.empName }}
                      </tds-body-cell>
                      <tds-body-cell cell-key="area">
                            {{ row.area }}
                      </tds-body-cell>
                      <tds-body-cell cell-key="username">
                            {{ row.username }}
                      </tds-body-cell>             
                  </tds-table-body-row>

                }
                
          </tds-table-body>
          <tds-table-footer
                pagination
                [pages]="pages()"
                (tdsPagination)="handlePagination($event)"
                [rowsPerPageValues]="rowsPerPageValuesArray"
            ></tds-table-footer>
        
      </tds-table>
      </div>
        
        
  </span>
<div slot="actions">
  <!-- <tds-button data-dismiss-modal size="md" text="Cancel"></tds-button> -->
</div>
</tds-modal>